/* eslint-disable react/prop-types */
import { Popover, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import ReplyIcon from "@material-ui/icons/Reply";

import "./popOver.css";
import { PopOverProps } from "../../../@types/components/popOverProps.types";

const useStyles = makeStyles(() => ({
	paper: {
		position: "absolute",

		minWidth: 16,
		minHeight: 16,
		maxWidth: "calc(100vw - 8px)",
		maxHeight: "calc(100vh - 8px)"
	}
}));

const PopOver = ({ anchorEl, popOverContent, setAnchorEl, popOverTitle }: PopOverProps) => {
	const classes = useStyles();
	const open = Boolean(anchorEl);
	const id = open ? "simple-popover" : undefined;

	const handleClose = () => {
		setAnchorEl(null);
	};

	const changePlanNameText = (planName: string) => {
		const text1 = planName.replaceAll("_", " ");
		const capitalized = text1.replace(/^./, text1[0].toUpperCase());
		return capitalized;
	};

	return (
		<Popover
			id={id}
			open={open}
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: "center",
				horizontal: "right"
			}}
			transformOrigin={{
				vertical: "top",
				horizontal: "left"
			}}
			PaperProps={{
				style: { width: "300px" }
			}}
			onClose={handleClose}
		>
			<div
				id="popOverArrow"
				className="pop-over-arrow"
				style={{
					width: "0",
					height: "0",
					borderLeft: "7px solid transparent",
					borderRight: "7px solid transparent",
					borderBottom: "15px solid #fff",
					zIndex: 9999,
					position: "absolute",
					top: 0,
					left: 30,
					right: 40,
					transition: "2s",
					transform: "translate(-50%, -50%) rotate(45deg)",
					display: "none"
				}}
			></div>
			<div className="pop-over-container">
				<div className="pop-over-title">{popOverTitle}</div>
				<Grid container spacing={1}>
					{Object.entries(popOverContent).map(([key, value], index) => {
						return (
							<>
								<Grid item xl={6} lg={6} md={6} sm={6} xs={6} key={index}>
									<div className="label-info">
										<span>
											<ReplyIcon
												style={{
													fontSize: "1.6rem",
													paddingTop: 12
												}}
											/>
										</span>
										<span>{changePlanNameText(key)}</span>
									</div>
								</Grid>
								<Grid item xl={6} lg={6} md={6} sm={6} xs={6} key={index}>
									<div className="value-text">{value}</div>
								</Grid>
							</>
						);
					})}
				</Grid>
			</div>
		</Popover>
	);
};

export default PopOver;
